import DashboardSiswa from "../components/DashboardSiswa/Home";

export default function AddPasien() {
  return (
    <div style={{backgroundColor:"white"}}>
      <DashboardSiswa/>
    </div>
  );
}
